import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInWhyBuyImageryExperiment() {
  return useIsInExperiment('car-merch-ui-vdp-why-buy-imagery', 'treatment');
}
